exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lm-Form{font-family:Roboto,Arial,sans-serif;-webkit-box-sizing:border-box;box-sizing:border-box;max-width:1152px;margin:0 auto}.lm-Form *{-webkit-box-sizing:inherit;box-sizing:inherit}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"includePaths":["./node_modules"]}!./node_modules/@lmig/lmds-react-form/dist/_esm/form.css
// module id = 2770
// module chunks = 0